const SPEAKER_SEPARATOR = ':：ঃઃ';
const SPEAKER_PREFIX_PATTERN = new RegExp(
  `^\\s*([^${SPEAKER_SEPARATOR}\\n]{1,100})\\s*[${SPEAKER_SEPARATOR}]\\s*([\\s\\S]*)$`,
  'u'
);

// Accept the ASCII source convention and common bracket variants produced by localization.
const FULL_STAGE_DIRECTION_PATTERN = /^\s*(?:[\u005b［【][\s\S]*[\u005d］】]|\([^()\r\n]*\)|（[^（）\r\n]*）)\s*$/u;
const INLINE_SQUARE_STAGE_DIRECTION_PATTERN = /\s*[\u005b［【][^\u005d］】\r\n]*[\u005d］】]\s*/gu;
const LEADING_PARENTHETICAL_PATTERN = /^\s*(?:(?:\([^()\r\n]*\)|（[^（）\r\n]*）)\s*)+/u;

export function parseConversationLine(value) {
  const text = typeof value === 'string' ? value : '';
  const match = text.match(SPEAKER_PREFIX_PATTERN);
  if (!match) return { speaker: null, line: text };
  return { speaker: match[1].trim(), line: match[2].trim() };
}

export function stripConversationSpeaker(value) {
  return parseConversationLine(value).line;
}

export function isConversationNarration(value) {
  return typeof value === 'string' && FULL_STAGE_DIRECTION_PATTERN.test(value);
}

export function getConversationSpeechText(value) {
  if (typeof value !== 'string' || isConversationNarration(value)) return '';

  return stripConversationSpeaker(value)
    .replace(LEADING_PARENTHETICAL_PATTERN, '')
    .replace(INLINE_SQUARE_STAGE_DIRECTION_PATTERN, ' ')
    .replace(/\s+([,.;:!?])/gu, '$1')
    .replace(/\s+/gu, ' ')
    .trim();
}
